import { Navigate, useLocation } from 'react-router-dom';
import { useContextStore } from '../hooks/context/useContextStore';
import { isImpersonating } from '../utils/impersonationSession';

interface AuthGuardProps {
  children: React.ReactNode;
  redirectTo?: string;
}

export function AuthGuard({ children, redirectTo = '/signin' }: AuthGuardProps) {
  const { clientUser } = useContextStore();
  const location = useLocation();

  if (!clientUser && !isImpersonating()) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  return <>{children}</>;
}

export function GuestGuard({ children }: { children: React.ReactNode }) {
  const { clientUser } = useContextStore();
  const location = useLocation();

  if (clientUser || isImpersonating()) {
    const routeState = location.state as {
      from?: { pathname?: string; search?: string } | string;
    } | null;
    const from =
      typeof routeState?.from === 'string'
        ? routeState.from
        : routeState?.from?.pathname
          ? `${routeState.from.pathname}${routeState.from.search || ''}`
          : '/dashboard';
    return <Navigate to={from} replace />;
  }

  return <>{children}</>;
}
